module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00045.f68e5f9.png";